/* eslint-disable max-len */
/* eslint-disable max-lines */

import 'dotenv/config'
import '../styles/mobile.css'
import '../styles/globals.css'
import '../styles/aggie/main.css'
import '../config/firebase.config'
import { AuthProvider } from '../hooks/auth'
import AuthStateChanged from '../components/AuthStateChanged'
import React, {useEffect, useRef, useState} from 'react'
// import Modal from 'react-responsive-modal'
// import 'react-responsive-modal/styles.css'
import Script from 'next/script'
import {getAuth, onAuthStateChanged} from 'firebase/auth'
import changelogList from '../pages/changelog.json'
import Head from 'next/head'
import { useRouter } from 'next/router'
import Index from '../pages/index'
import hs from '../services/helperService'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ReactGA from 'react-ga4'
import { VarsContext } from '../components/context/VarsContext'
import * as Sentry from '@sentry/nextjs'
import tailwindGroups from '../services/tailwindGroups'
import GlobalModalComponent from '../components/aggie/modals/GlobalModalComponent'
import useJoyrideStore from '../services/aggie/useJoyrideStore'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'

if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_URL.includes('dev')){
	// const tagManagerArgs = {
	// 	gtmId: 'GTM-KLBXLK69'
	// }

	ReactGA.initialize('G-1G71JPCDG0', { gtagUrl:`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`})
	// TagManager.initialize(tagManagerArgs)
}

function MyApp({ Component, pageProps }) {
	const [tooltipContent, setTooltipContent] = useState(null),
		[tooltipStyle, setTooltipStyle] = useState({}),
		[isLoading, setIsLoading] = useState(true),
		[vars, setVars] = useState({
			user: 'logged out',
			version: `Beta 2.1.${changelogList?.length - 140}`
		}),
		router = useRouter(),
		tooltipRef = useRef(null),
		securePages = ['/settings', '/pipeline', '/tools', '/changelog'],
		tierTwoPages = ['/account', '/report', '/planner', '/support', '/dashboard', '/assets',
			'/features', '/connect', '/metaToken', '/linkedInToken', '/twitterToken', '/connectToSocial', '/subscription', '/profile', '/aggie/admanager', 'thankyou', '/tiktokToken', '/setup', '/dashboard', 'youtubeToken', '/competitors'],
		tierThreePages = tierTwoPages.concat(['/report']), //'/setup', // /planner to be added after completion
		publicPages = ['/signup', '/contact', '/tos', '/privacy', '/faq', '/webUser', '/handleEmailPostAction', '/joinA', '/joinB', '/joinC', '/renew', '/affiliate', '/join'],
		// Handle Joyride callbacks
		handleJoyrideCallback = (data) => {
			const { action, status, type, index } = data

			if (action === ACTIONS.CLOSE) {
				resetTour()
			}

			if (
				type === EVENTS.STEP_AFTER &&
			action === ACTIONS.NEXT &&
			index === index + 1 // Step before the final step (Connections tab)
			) {
			// Wait until the target element is available
				const waitForElement = setInterval(() => {
					if (document.querySelector('#joyride-preferences-connections-social-channels')) {
						clearInterval(waitForElement)
						updateStepIndex(index + 1)
					}
				}, 500) // Check every 500ms
			} else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type) && action === ACTIONS.NEXT) {
				updateStepIndex(index + 1)
			}

			if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
				resetTour()
			}
		},
		// zoho trash code
		ZohoScript = ({zohoCode, url}) => {
			useEffect(() => {
				const script = document.createElement('script')
				script.setAttribute('type', 'text/javascript')

				// eslint-disable-next-line max-len
				let code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "${zohoCode}", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="${url}";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.innerHTML = "<div id='zsiqwidget'></div>";`

				script.appendChild(document.createTextNode(code))
				document.body.appendChild(script)

				return () => {
					document.body.removeChild(script)
				}
			}, [url])
		},
		/**
		 * @author Jared
		 * @description Run an alert (currently at the bottom) for a given amount of time
		 *
		 * @param {string} content - the text of the alert
		 * @param {string} [type] - the type of alert, default type is info
		 * @param {number} [timeout] - the amount of time the alert should be displayed
		 *
		 * @return null - loads a component
		 */
		alert = (content, type, timeout) => {
			if (content)
				toast[type || 'info'](content, { autoClose: timeout || 3000 })
			else
				toast.dismiss()
		},
		tour = (which, force) => {
			if (!force && (!vars.user || !vars.user.preferences))
				return
			if (!vars.user.preferences?.completedTours)
				vars.user.preferences.completedTours = {}
			if (force || !vars.user.preferences.completedTours[which]) {
				hs.basicLog('Tour has been initiated on: ' + which, 'Unknown', vars.user)
				setSteps(tours[which].steps)
				startTour()
				vars.user.preferences.completedTours[which] = {
					started: true,
					date: new Date()
				}
				setVars(structuredClone(vars))
				hs.manage(vars.user, 'User')
			}
		},
		// function
		tooltip = (content, event) => {
			setTooltipContent(content)
			if (event) {
				const rectangle = (event.currentTarget || event.target)?.getBoundingClientRect()
				if (rectangle && rectangle.left + 'px' !== tooltipStyle.left)
					setTooltipStyle({
						zIndex: 99999,
						left: rectangle.left + 'px',
						top: (rectangle.top + rectangle.height + 10) + 'px'
					})
			}
			window.setTimeout(() => {
				if (tooltipContent === content)
  				setTooltipContent(null)
			}, 5000)
		},
		varsSetter = async(user, data) => {
			onAuthStateChanged(getAuth(), async updatedUser => {
				if (updatedUser) {
					// check for live tests
					let updated = false

					const userTests = user.local?.tests || [],
						liveTests = hs.vars.tests.filter(test => test.status === 'live')
					if (liveTests.length > 0) {
						// make sure the user is running every live test
						liveTests.forEach(test => {
							if (userTests.findIndex(userTest => userTest.name === test.name) === -1) {
								const condition = test.conditions[Math.floor(Math.random() * test.conditions.length)]['name']
								userTests.push({
									name: test.name,
									// get a random condition element based on the length of test.conditions
									condition
								})
								hs.basicLog(`User has been added to test: ${test.name} with condition ${condition}.`, 'Bootstrap', user)
								updated = true
							}
						})
						if (updated) {
							user.local.tests = userTests
							hs.updateProfile(user, 'local', user.local)
						}
					}

					vars.user = user
					vars.stopwords = data?.stopwords?.split(',').map(stopword => stopword.trim().toLowerCase())
					if (vars.user.userType === 'admin')
						vars.teams = data.teams
					if (vars.user.team)
						vars.team = data.team
					if (vars.user?.role === 'webUser')
						vars.team = vars.user.team
					vars.clusters = data.clusters
					vars.verticals = data.verticals?.sort((a, b) => a.name.localeCompare(b.name))
					vars.quotes =  data.quotes
					vars.successManager = data?.successManager
					setVars(structuredClone(vars))
					setTimeout( () => {
						setIsLoading(false)
					}, 500)
				}
				else {
					setIsLoading(false)
					setVars({ user: 'logged out'})
				}
			})
		},
		isAdmin = hs.admin(vars),
		isWebUser = vars.user.role === 'webUser',
		isValidPlan = vars.user.isValidPlan,
		currentPath = global?.location?.pathname ||  '',
		unauthorizedAccess =
			publicPages.filter(page => global?.location?.pathname.indexOf(page) > -1)?.length === 0 && (
				(!isAdmin && securePages.some(page => currentPath.includes(page))) ||
				(isWebUser && isValidPlan && hs.tier(vars) < 3 && !tierTwoPages.some(page => currentPath.includes(page)) && currentPath !== '/') ||
				(isWebUser && isValidPlan && hs.tier(vars) > 2 && !tierThreePages.some(page => currentPath.includes(page)) && currentPath !== '/') ||
				(isWebUser && !isValidPlan && currentPath !== '/' && !currentPath.includes('account')) ||
				(vars.user.role !== 'webUser' && global?.location?.pathname !== '/profile'  && (tierTwoPages.includes(global?.location?.pathname) || tierThreePages.includes(global?.location?.pathname))
				))

	// if (tierThreePages.concat(publicPages).filter(page => global?.location?.pathname.indexOf(page) > -1)?.length > 0) {
	// 	require('../styles/WebUser/globals.css')
	// }
	// else
	// 	require('../styles/globals.css')

	/* JOYRIDE TUTORIAL IMPORT */
	const { steps, run, updateStepIndex, startTour, resetTour, setSteps, getCurrentJoyrideStep } = useJoyrideStore(),
		tours = {
			whatsNew: {
				title: 'What\'s New',
				completed: false,
				steps: [
					{
						content: <>
							<i className="fal fa-calendar-alt text-[4rem] mb-3" />
							<h2 className={'text-2xl uppercase'}>Meet the Planner</h2>
							<p className='mt-1'>Ready to make posting simpler? This layout is built for busy people who need quick wins and less hassle.</p>
							<div className='w-full flex justify-center mt-4'>
								<button className='hover:bg-[#2b2b2b] bg-black text-white px-6 py-2 text-xl rounded-2xl uppercase w-full mt-2'
									onClick={() => updateStepIndex(getCurrentJoyrideStep() + 1)}>
									5 Planner Features<i className="fa fa-chevron-right ml-2 " />
								</button>
							</div>
						</>,
						// locale: { skip: <strong aria-label="skip">Skip Tutorial</strong> },
						placement: 'center',
						styles: {
							options: {
								width: 400
							}
						},

						target: 'body',
						hideFooter: true, // Hide the footer for this step
					},
					{
						target: '.jr-calendar',
						content: 'See your month at a glance. Plan smarter and manage your content without the chaos.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-list',
						content: 'See every post in detail! The List View makes it easy to review, edit, and fine-tune your content.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-optimizer',
						content: 'Posts aren’t hitting the mark yet? No worries—we’ve got the tools to get you there.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-more',
						content: 'Need options fast? Tap here for tools that save time and get the job done.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-counter',
						content: 'Feel confident knowing how many posts you have left—no surprises, just clarity.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select
						locale: { last: 'Done' }
					},
					// {
					// 	target: '.jr-menu-admanager',
					// 	content: 'Easily create, manage, and track your ads. Our new Ad Manager is your one-stop shop for all things advertising.',
					// 	placement: 'right',
					// 	placementBeacon: 'right',
					// 	spotlightClicks: true, // Allows for user to select element
					// 	locale: { last: 'Done' }
					// }
				]
			},
			optimizer: {
				title: 'Optimizer',
				completed: false,
				steps: [
					{
						content:
							<>
								<i className="fal fa-star text-[4rem] mb-3" />
								<h2 className={'text-2xl uppercase'}>Improve My Posts</h2>
								<p className='mt-1'>Posts aren’t hitting the mark yet? No worries—we’ve got the tools to get you there.</p>
								<div className='w-full flex justify-center mt-4'>
									<button className='hover:bg-[#2b2b2b] bg-black text-white px-6 py-2 text-xl rounded-2xl uppercase w-full mt-2'
									        onClick={() => updateStepIndex(getCurrentJoyrideStep() + 1)}>
										Check it Out <i className="fa fa-chevron-right ml-2 " />
									</button>
								</div>
							</>,
						// locale: { skip: <strong aria-label="skip">Skip Tutorial</strong> },
						placement: 'center',
						target: 'body',
						hideFooter: true, // Hide the footer for this step
					},
					{
						target: '.jr-yourContent',
						content: 'Got great content? Use it! Upload and let it keep working wonders for your brand.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-yourIndustry',
						content: 'Tailored for your industry. Set it up once, and we’ll make your content work harder for you.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-contactUs',
						content: 'Real people, real answers. Contact us for help anytime—we’re here for you.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
						locale: { last: 'Done' }
					}
				]
			},
			editor: {
				title: 'Editor',
				completed: false,
				steps: [
					{
						content:
							<>
								<i className="fal fa-pencil text-[4rem] mb-3" />
								<h2 className={'text-2xl uppercase'}>Post Editor</h2>
								<p className='mt-1'>Use the Edit Tools to modify your posts with images, text, and more. Click here to get started.</p>
								<div className='w-full flex justify-center mt-4'>
									<button className='hover:bg-[#2b2b2b] bg-black text-white px-6 py-2 text-xl rounded-2xl uppercase w-full mt-2'
									        onClick={() => updateStepIndex(getCurrentJoyrideStep() + 1)}>
										Check it Out <i className="fa fa-chevron-right ml-2 " />
									</button>
								</div>
							</>,
						placement: 'center',
						target: 'body',
						hideFooter: true, // Hide the footer for this step
					},
					{
						target: '.jr-editText',
						content: 'Captions sell. Edit yours here to make every word earn its keep.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImage',
						content: 'Click here to change or modify your post’s image. Adjust, or replace in seconds.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
						locale: { last: 'Done' }
					}
				]
			},
			editorText: {
				title: 'Text Editor',
				completed: false,
				steps: [
					{
						content:
							<>
								<i className="fal fa-pencil text-[4rem] mb-3" />
								<h2 className={'text-2xl uppercase'}>Text Editor</h2>
								<p className='mt-1'>Captions sell. Edit yours here to make every word earn its keep.</p>
								<div className='w-full flex justify-center mt-4'>
									<button className='hover:bg-[#2b2b2b] bg-black text-white px-6 py-2 text-xl rounded-2xl uppercase w-full mt-2'
									        onClick={() => updateStepIndex(getCurrentJoyrideStep() + 1)}>
										Check it Out <i className="fa fa-chevron-right ml-2 " />
									</button>
								</div>
							</>,
						placement: 'center',
						target: 'body',
						hideFooter: true, // Hide the footer for this step
					},
					{
						target: '.jr-editTextVoice',
						content: 'Choose the right voice for posts that connect.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editTextTopics',
						content: 'Ideas, instantly. Add relevant topics to make creating content easier than ever.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editTextCTA',
						content: 'CTAs that convert. Add them here and watch your engagement soar.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editTextLength',
						content: 'Too long? Too short? Fix it here and make it just right.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editTextRewrite',
						content: 'Overthinking captions? Rewrite them in seconds to save time and effort.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editTextDone',
						content: 'When you\'re all done, click here!',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
						locale: { last: 'Done' }
					}
				]
			},
			editorImage: {
				title: 'Image Editor',
				completed: false,
				steps: [
					{
						content:
							<>
								<i className="fal fa-pencil text-[4rem] mb-3" />
								<h2 className={'text-2xl uppercase'}>Image Editor</h2>
								<p className='mt-1'>Change or modify your post’s image. Adjust, or replace in seconds.</p>
								<div className='w-full flex justify-center mt-4'>
									<button className='hover:bg-[#2b2b2b] bg-black text-white px-6 py-2 text-xl rounded-2xl uppercase w-full mt-2'
									        onClick={() => updateStepIndex(getCurrentJoyrideStep() + 1)}>
										Check it Out <i className="fa fa-chevron-right ml-2 " />
									</button>
								</div>
							</>,
						placement: 'center',
						target: 'body',
						hideFooter: true, // Hide the footer for this step
					},
					{
						target: '.jr-editImageTemplates',
						content: 'Make your images pop with ready-to-use design templates.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImageTextAndImages',
						content: 'Easily customize your images by adding text, logos, and product cutouts.  No design skills needed.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImageBackground',
						content: 'Swap out the background for a new look.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImageCarousel',
						content: 'You can add up to 10 photos in a carousel for users to swipe through. It’s great for storytelling, tutorials, or showcasing products. Boosts engagement and keeps followers on your post longer.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImageMatchImageToCaption',
						content: 'Does your image not match your message? Generate a new one that does.',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
					},
					{
						target: '.jr-editImageDone',
						content: 'When you\'re all done, click here!',
						placement: 'right',
						placementBeacon: 'right',
						spotlightClicks: true, // Allows for user to select element
						locale: { last: 'Done' }
					}
				]
			}
		}

	useEffect(() => {
		if (vars?.user !== 'logged out') {
			Sentry.setTag('currentUser', vars?.user?.email)
		}
	}, [vars?.user?.email])

	return (
		<AuthProvider>
			<AuthStateChanged setter={varsSetter} alert={alert}>
				<div id="modalRoot" className={vars?.user?.preferences?.theme === 'dark' ? 'dark' : ''}></div>
				{/* Gives entire app access to global modal component. DO NOT REMOVE */}
				<GlobalModalComponent />
				<ToastContainer position='top-right' hideProgressBar={true} theme={'colored'} autoClose style={{zIndex: 10002}} />
				<script type="text/javascript">{'(function(w,s){var e=document.createElement("script");e.type="text/javascript";e.async=true;e.src="https://cdn.pagesense.io/js/audiencegenomics/4693bce6735e461ebf00c1d770f05e51.js";var x=document.getElementsByTagName("script")[0];x.parentNode.insertBefore(e,x);})(window,"script");'}</script>
				<Script id="facebookPixel">
					{`
						!function(f,b,e,v,n,t,s)
						{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
							n.callMethod.apply(n,arguments):n.queue.push(arguments)};
							if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
							n.queue=[];t=b.createElement(e);t.async=!0;
							t.src=v;s=b.getElementsByTagName(e)[0];
							s.parentNode.insertBefore(t,s)}(window, document,'script',
						'https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '1122216199200215');
						fbq('track', 'PageView');
						`}
				</Script>
				<Script id='gtm'>
					{
						`
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','GTM-KLBXLK69');
						`
					}
				</Script>
				{(() => {
					if (unauthorizedAccess && vars?.user?.role === 'webUser' && !vars?.user?.isValidPlan) {
						if (!vars?.isValidPlan) {
							router.push('/renew')
						} else {
							router.push('/signup')
						}
					} else if (unauthorizedAccess) {
						return (
							<>
								<Head>
									<title>Unauthorized</title>
									<meta charSet="utf-8" />
									<meta name="viewport" content="initial-scale=1.0, width=device-width" />
									<link rel="icon" type="image/png" sizes="32x32" href="/favicon.png" />
									<meta name="msapplication-TileColor" content="#da532c" />
								</Head>
								<div style={{padding: '3rem 3rem'}} className="bg-[#2b2b2b] text-white h-[100vh]">
									<div className='mx-auto max-w-4xl'>
										<div className='flex justify-center'>
											<img src='https://dev.letaggiedoit.com/images/emailHeader.jpg'
											     className='w-full h-64 object-cover rounded-lg' alt="Header" />
										</div>

										<h2 className={`${tailwindGroups.h1} mb-4 mt-12`}>It's not you, it's me!</h2>
										<p>Whether you landed on a page not meant for you, or you ran into an unexpected error,
											please accept our apologies. Please reach out to your success rep if this keeps happening. Otherwise, please return <span className="text-aggie-yellow"
											                                                                                   onClick={() => {
												                                                                                   if (vars.user.role ===
													                                                                                   'webUser') {
													                                                                                   router.push(
														                                                                                   vars.user.isValidPlan ?
															                                                                                   '/planner' :
															                                                                                   '/signup')
														                                                                                   .then(
															                                                                                   () => {
																                                                                                   // Force a reload after navigation
																                                                                                   window.location.reload()
															                                                                                   })
												                                                                                   } else {
													                                                                                   router.push(
														                                                                                   '/').then(
														                                                                                   () => {
															                                                                                   // Force a reload after navigation
															                                                                                   window.location.reload()
														                                                                                   })
												                                                                                   }
											                                                                                   }}>home</span>.</p>

										<button
											className={`${tailwindGroups.primaryButton} mt-8`}
											onClick={() => {
												if (vars.user.role === 'webUser') {
													router.push(vars?.user.isValidPlan ? '/planner' : '/signup')
												} else {
													router.push('/')
												}
											}}
										>
											Return Home
										</button>
									</div>
								</div>
							</>
						)
					} else if (tierThreePages.concat(publicPages).filter(page => global?.location?.pathname.indexOf(page) > -1)?.length > 0) {
						return (
							<>
								<VarsContext.Provider value={{vars, alert, tooltip}}>
									<Component {...pageProps} tour={tour} tooltip={tooltip} alert={alert} vars={vars} />
									<Joyride
										steps={steps}
										run={run}
										stepIndex={getCurrentJoyrideStep()}
										continuous
										callback={handleJoyrideCallback}
										hideBackButton={true}
										hideCloseButton={false}
										scrollToSteps={true}
										styles={{
											options: {
												zIndex: 10000,
												arrowColor: '#FFCE1A',
												backgroundColor: '#1b1b1b',
												overlayColor: 'rgba(20,20,20,0.8)',
												primaryColor: '#000',
												textColor: '#fff',
												width: 400,
												beaconSize: 5
											}
										}}
									/>
								</VarsContext.Provider>
								<ZohoScript zohoCode="siqce8b26f8928b8be4298b01941a56e562" url="https://salesiq.zoho.com/widget" />
								{process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS && (
									<>
										<Script
											src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
											strategy="afterInteractive"
										/>
										<Script id="google-analytics" strategy="afterInteractive">
											{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('set', {
				'custom_map': {
					'userId': 'userId',
					'userEmail': 'userEmail',
					'userTeam': 'userTeam'
				}
			});
          gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', { 'userId':'${vars?.user?._id}', 'userEmail':'${vars?.user?.email}', 'userTeam':"${encodeURIComponent(
										vars?.team?.name)}" });
        `}
										</Script>

										<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLBXLK69"
										        height="0" width="0" style={{display: 'none', visibility: 'hidden'}}></iframe>
									</>
								)}
								{router.pathname === '/signup' && <Script id="facebook-pixel" strategy="afterInteractive">
									{`
										!function(f,b,e,v,n,t,s)
										{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
										n.callMethod.apply(n,arguments):n.queue.push(arguments)};
										if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
										n.queue=[];t=b.createElement(e);t.async=!0;
										t.src=v;s=b.getElementsByTagName(e)[0];
										s.parentNode.insertBefore(t,s)}(window, document,'script',
											'https://connect.facebook.net/en_US/fbevents.js');
										fbq('init', '${process.env.NEXT_PUBLIC_FB_PIXEL_ID}');
										fbq('track', 'PageView');
									`}
								</Script>}
								{router.pathname === '/signup' && <Script id="tiktok-pixel" strategy="afterInteractive">
									{`!function (w, d, t) {
										w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
ttq.load('CO7B3RBC77U7F073BE50');
ttq.page();
}(window, document, 'ttq');`
									}
								</Script>}

								{tooltipContent && (
									<div className="tooltip bg-aggie-dark-gray px-2 py-1 text-xs fixed text-white rounded-md" ref={tooltipRef} style={tooltipStyle}>{tooltipContent}</div>
								)}
							</>
						)
					} else if (vars.user === 'logged out' && publicPages.filter(page => global?.location?.pathname.indexOf(page) > -1)?.length ===
						0) {
						return <Index {...pageProps} tooltip={tooltip} alert={alert} vars={vars} />
					}
					// else if (vars.user === 'logged out'){
					// 	return <Signup {...pageProps} tooltip={tooltip} alert={alert} vars={vars} />
					// }
					else if (vars.user && vars.user !== 'logged out' && !isLoading &&
						(hs.admin(vars) || securePages.filter(page => global?.location?.pathname.indexOf(page) > -1)?.length === 0)) {
						return (
							<div className="toolipClickOff" onClick={() => {
								tooltip(null, null)
							}}>
								<Component {...pageProps} tooltip={tooltip} alert={alert} vars={vars} />
								<ZohoScript zohoCode="siqce8b26f8928b8be4298b01941a56e562" url="https://salesiq.zoho.com/widget" />
								{process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS && vars.user && (
									<>
										<Script
											src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
											strategy="afterInteractive"
										/>
										<Script id="google-analytics" strategy="afterInteractive">
											{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('set', {
				'custom_map': {
					'userId': 'userId',
					'userEmail': 'userEmail',
					'userTeam': 'userTeam'
				}
			});
          gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', { 'userId':'${vars.user._id}', 'userEmail':'${vars.user.email}', 'userTeam':"${encodeURIComponent(
										vars.team?.name)}" });
        `}
										</Script>
									</>
								)}
								{tierThreePages.includes(router.pathname) && <Script id="facebook-pixel" strategy="afterInteractive">
									{`
										!function(f,b,e,v,n,t,s)
										{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
										n.callMethod.apply(n,arguments):n.queue.push(arguments)};
										if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
										n.queue=[];t=b.createElement(e);t.async=!0;
										t.src=v;s=b.getElementsByTagName(e)[0];
										s.parentNode.insertBefore(t,s)}(window, document,'script',
											'https://connect.facebook.net/en_US/fbevents.js');
										fbq('init', ${process.env.NEXT_PUBLIC_FB_PIXEL_ID});
										fbq('track', 'PageView');
									`}
								</Script>}
								{/*{modalContent && (*/}
								{/*	// <Modal*/}
								{/*	// 	open*/}
								{/*	// 	closeOnEsc={false}*/}
								{/*	// 	onClose={modalOnClose}*/}
								{/*	// 	classNames={{*/}
								{/*	// 		modal: 'h-[calc(100vh-6rem)] w-[calc(100vw-6rem)] p-10 max-w-[calc(100vw-6rem)] mt-[3rem] rounded-2xl drop-shadow-lg enterpriseModal',*/}
								{/*	// 		closeButton: 'infoModalCloseHidden postModalClose',*/}
								{/*	// 		modalContainer: 'bg-[#090910]'*/}
								{/*	// 	}}*/}
								{/*	// 	styles={modalStyles}*/}
								{/*	// >{modalContent}</Modal>*/}
								{/*)}*/}
								{tooltipContent && (
									<div className="tooltip" ref={tooltipRef} style={tooltipStyle}>{tooltipContent}</div>
								)}
							</div>
						)
					}
				})()}
			</AuthStateChanged>
		</AuthProvider>
	)
}

export default MyApp
